/**
 * Preisstufen-Filter-Pills fuer Netzfarbe (ShopPad Infinite Options). v6
 * Pill-Leiste ueber den Netzfarben-Swatches. Filtert nach Preisstufe.
 *
 * Tier-Erkennung: Aus dem option-value-Suffix "(+ X €)" wird der Aufpreis
 * extrahiert und auf eine Stufe gemappt. Farben ohne Suffix = standard (0€).
 *
 * Stufen (Stand KW24, Preissenkung extended+line):
 *   - standard :  0 € (Schwarz, Gold, Gelb, Orange, Blau, ...)
 *   - extended : 20 € (vorher 30 €) (Weiss, Bordeaux, Marineblau, ...)
 *   - premium  : 40 € (Royalrot, Mandarin, Limette, ...)
 *   - knit     : 55 € (Knit-Blau, Knit-Gelb, ...)
 *   - special  : 75 € (DE, Race)
 *   - line     : 65 € (vorher 85 €) (Blue Line, M-Line 1, ...)
 *
 * Die "(+ X €)"-Labels kommen aus dem ShopPad-Setup (Option-Value-Namen),
 * nicht aus dem Theme. PRICE_TO_TIER mappt bewusst ALT+NEU (20 und 30, 65 und
 * 85), damit der Filter waehrend der Label-Umstellung und gegen Admin-Saves
 * stabil bleibt — egal welcher Preis aktuell im Label steht.
 * Cart-Rabattaktionen beeinflussen die Pill-Logik nicht.
 */
(function () {
  'use strict';

  // Sprache aus <html lang> (EN-Storefront = 'en') fuer Pill-/ARIA-Labels
  const SP_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

  const SWATCH_WRAPPER = '.spb-productoptionswatchwrapper';
  const INPUT_SELECTOR = 'input[name="properties[Netzfarbe]"]';
  const READY_MARKER = 'data-sp-filter-ready';

  const TIERS = [
    { id: 'all',      label: SP_EN ? 'All' : 'Alle' },
    { id: 'standard', label: 'Standard' },
    { id: 'extended', label: 'Extended' },
    { id: 'premium',  label: 'Premium' },
    { id: 'knit',     label: 'Knit' },
    { id: 'special',  label: 'Special' },
    { id: 'line',     label: 'Line' },
  ];

  const PRICE_TO_TIER = {
    20: 'extended', // KW24 neu
    30: 'extended', // alt, Uebergangsfenster
    40: 'premium',
    55: 'knit',
    75: 'special',
    65: 'line',     // KW24 neu
    85: 'line',     // alt, Uebergangsfenster
  };

  function tierFor(value) {
    const m = (value || '').match(/\(\s*\+\s*(\d+)\s*€\s*\)/);
    if (!m) return 'standard';
    return PRICE_TO_TIER[parseInt(m[1], 10)] || 'extended';
  }

  function tagSwatches() {
    document.querySelectorAll(INPUT_SELECTOR).forEach((input) => {
      const wrapper = input.closest(SWATCH_WRAPPER);
      if (!wrapper) return;
      wrapper.setAttribute('data-tier', tierFor(input.value));
    });
  }

  function buildPillsNav() {
    const nav = document.createElement('nav');
    nav.className = 'sp-filter-pills';
    nav.setAttribute('aria-label', SP_EN ? 'Filter by net color' : 'Filter nach Netzfarben-Kategorie');
    TIERS.forEach((t, idx) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sp-pill' + (idx === 0 ? ' is-active' : '');
      btn.dataset.filter = t.id;
      btn.textContent = t.label;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        applyFilter(nav, t.id);
      });
      nav.appendChild(btn);
    });
    return nav;
  }

  function applyFilter(nav, tier) {
    nav.querySelectorAll('.sp-pill').forEach((p) => {
      p.classList.toggle('is-active', p.dataset.filter === tier);
    });
    document.querySelectorAll(INPUT_SELECTOR).forEach((input) => {
      const wrapper = input.closest(SWATCH_WRAPPER);
      if (!wrapper) return;
      const swatchTier = wrapper.getAttribute('data-tier');
      const visible = tier === 'all' || swatchTier === tier;
      wrapper.toggleAttribute('data-tier-hidden', !visible);
    });
  }

  function ensurePills() {
    const firstInput = document.querySelector(INPUT_SELECTOR);
    if (!firstInput) return false;
    const firstWrapper = firstInput.closest(SWATCH_WRAPPER);
    if (!firstWrapper || !firstWrapper.parentElement) return false;
    if (firstWrapper.parentElement.hasAttribute(READY_MARKER)) return true;

    tagSwatches();
    const nav = buildPillsNav();
    firstWrapper.parentElement.insertBefore(nav, firstWrapper);
    firstWrapper.parentElement.setAttribute(READY_MARKER, '');
    return true;
  }

  function start() {
    if (ensurePills()) return;
    const observer = new MutationObserver(() => {
      if (ensurePills()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
